import { _$ } from './Fascino.js'
import { Fascino } from './core.js'
import './Plugins';

export {
	_$,
	Fascino
}